var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitalWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M138.766,152.557c-2.717-7.79-4.194-16.161-4.194-24.877c0-41.704,33.808-75.512,75.512-75.512s75.512,33.808,75.512,75.512 c0,8.716-1.477,17.088-4.194,24.877"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M226.983,153.049c4.975-9.027,2.923-21.398-9.479-25.782c-9.094-3.215-15.842-6.106-20.326-9.624 c-7.81-6.126-4.956-21.851,6.537-25.313c12.517-3.771,20.637,3.719,20.637,3.719l1.117,0.862"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 209.63,
    y1: 81.579,
    x2: 209.63,
    y2: 90.131
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M286.541,56.914c17.206,18.581,27.723,43.446,27.723,70.767c0,8.573-1.036,16.905-2.989,24.876"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M108.799,152.171c-1.893-7.854-2.895-16.056-2.895-24.491c0-57.537,46.643-104.18,104.18-104.18 c17.962,0,34.862,4.546,49.613,12.549"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 57.975,318.85 121.205,226.198 196.162,226.198 \t"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 11.5,
    y1: 320.668,
    x2: 249.687,
    y2: 320.668
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 276.261,
    cy: 320.668,
    r: 25.604
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2273 -0.9738 0.9738 0.2273 -47.06 393.0886)",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 224.162,
    cy: 226.198,
    rx: 25.604,
    ry: 25.604
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -228.599 280.3906)",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 224.162,
    cy: 416.139,
    rx: 25.604,
    ry: 25.604
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2808 -0.9598 0.9598 0.2808 -20.9907 614.3253)",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 399.404,
    cy: 321.168,
    rx: 16.418,
    ry: 16.418
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M311.582,94.5H380c16.385,0,29.668,13.283,29.668,29.668v29.668h-372.5c-16.385,0-29.668-13.283-29.668-29.668v0 C7.5,107.783,20.783,94.5,37.168,94.5h71.765"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M474.5,272.877v-89.372c0-16.385-13.283-29.668-29.668-29.668h-34.163"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M7.5,125.169v333.663c0,16.385,13.283,29.668,29.668,29.668h407.664c16.385,0,29.668-13.283,29.668-29.668v-89.806"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 172.924,
    y1: 416.139,
    x2: 194.162,
    y2: 416.139
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 56.734,321.668 121.205,416.139 140.237,416.139 \t"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M399.404,276.517c-24.66,0-44.651,19.991-44.651,44.651v0c0,24.66,19.991,44.651,44.651,44.651H489.5c8.284,0,15-6.716,15-15 v-59.302c0-8.284-6.716-15-15-15h-56.415"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalWallet);
export default __webpack_public_path__ + "static/media/digital-wallet.4d0a73e57812f2dfb3566e435e4260ee.svg";
export { ForwardRef as ReactComponent };